/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useEffect, useState } from 'react';
import $ from 'jquery';
import { FaTimes } from 'react-icons/fa';
import './style.scoped.scss';

const FilterModal = ({ modalText, options, handleApplyFilter, DDLName }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    $('#filterModal').on('hide.bs.modal', () => {
      setValue('');
    });
  }, []);

  const handleFilterChange = (data) => {
    setValue(data);
  };

  const handleClearModal = () => {
    setValue('');
    $('#filterModal').modal('hide');
  };

  const applyFilter = () => {
    handleApplyFilter(DDLName, value);
  };

  return (
    <div
      className="modal"
      id="filterModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-md" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="m-0">Filter By</h4>
            <FaTimes onClick={() => $('#filterModal').modal('hide')} className="position-relative" />
          </div>
          <div className="modal-body">
            <p>{modalText}</p>
            <div className="w-100">
              <select id="filter-DDList"
                className="form-control"
                value={value}
                onChange={(option) => handleFilterChange(option.target.value)}
              >
                {options && options.length > 0 && [
                  { text: '-Select-', value: '-Select-' },
                  ...options
                ].map((option, index) => (
                  <option value={option.value} key={index}>
                    {option.text}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn cancel"
              onClick={handleClearModal}
            >
              Cancel
            </button>
            <button
              disabled={value.length === 0 || value === '-Select-'}
              className="btn apply"
              onClick={applyFilter}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
